import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CompanyFilter from "../../../../app/core/components/CompanyFilter/CompanyFilter";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelect from "../../../../app/core/components/CoreSelect/CoreSelect";
import CoreSelectObjArr from "../../../../app/core/components/CoreSelect/CoreSelectObjArr";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import StudioFilter from "../../../../app/core/components/UserFilter/StudioFilter";
import { filterRoles, ROLE } from "../../../../utils/constants/profiles";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import { isEmailValid } from "../../../../utils/functions/form";
import { useGetCompaniesQuery } from "../../../api/admin/adminCompany";
import { useGetProfileCategoryQuery } from "../../../api/admin/gestioneNewsApi";
import { useCreateCommercialistaMutation } from "../../../api/admin/gestisciCommercialistiApi";
import {
  useGetStudioIdQuery,
  useGetStudiosQuery,
} from "../../../api/admin/gestisciStudioApi";
import { useCreateUserMutation } from "../../../api/admin/gestisciUtentiApi";
import { useGetRolesQuery } from "../../../api/admin/rolesApi";

export const FormCreaUtente = ({ onClose = () => {}, isOperator }) => {
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);
  const subRole = useSelector((state) => state.app.subRole);
  const myStudioId = useSelector((state) => state.app.studioId);
  const myAdminId = useSelector((state) => state.app.adminId);
  const ruoli = [t("User"), t("Operator")];
  const [studio, setStudio] = useState();
  const [formData, setFormData] = useState({
    role: isOperator ? t("Operator") : t("User"),
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [isNewStudio, setIsNewStudio] = useState(false);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const [person, setPerson] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState();
  const [debouncedInputCompanyValue, setDebouncedInputCompanyValue] =
    useState("");
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const sendEmailOption = appConfig?.modules?.user?.sendEmailCreated;
  const [sendEmail, setSendEmail] = useState(true);

  const page = {
    currentPage: 1,
    startRow: 0,
    endRow: 1000,
  };

  const [createUser, { isLoading: isUserLoading }] = useCreateUserMutation();
  const [createCommercialista, { isLoading: isCommercialistaLoading }] =
    useCreateCommercialistaMutation();

  //API GET RTK
  const {
    data: companiesList,
    isLoading: isCompanyLoading,
    isFetching: isCompanyFetching,
  } = useGetCompaniesQuery({ ...page, query: debouncedInputCompanyValue });

  const { data: studios, isLoading: isLoadingStudios } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: TABLE_ROWS_NUMBER },
    value: debouncedInputStudioValue,
  });

  const {
    data: datas,
    isLoading,
    isFetching,
  } = useGetStudioIdQuery(formData.studioId, { skip: !formData.studioId });

  const { data: adminRoles } = useGetRolesQuery();

  const filteredRoles = filterRoles(adminRoles?.Data, role, subRole, true);

  const OPERATOR_TYPES = filteredRoles.map((type) => ({
    label: type.name,
    value: type.id,
  }));

  const commercialistiOptions = datas?.Data?.admins?.map((user) => ({
    label: `${user?.name} ${user.surname}`,
    value: user?.id,
  }));

  const { data: dataListCategory, isLoading: isLoadingListCategory } =
    useGetProfileCategoryQuery(formData.role, {
      skip: formData.role !== t("User"),
    });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "adminProfileRoles") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: [value],
      }));
      return;
    }
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSendEmailChange = (event) => {
    setSendEmail(event.target.value === "true");
  };

  const handleSubmit = async () => {
    setValidationErrors({});
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    const id = toast.loading(
      t(
        formData.role === t("User") ? "UserCreating..." : "OperatorCreating..."
      ),
      { type: "info" }
    );

    const userData = buildUserData();

    const mutation =
      formData.role === t("Operator") ? createCommercialista : createUser;

    try {
      const res = await mutation(userData).unwrap();

      if (res.Result !== 1) {
        toast.update(id, {
          render:
            res.Exception ||
            t(`${formData.role === t("User") ? "User" : "Operator"}NotCreated`),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
        return;
      }

      toast.update(id, {
        render:
          res.Exception ||
          t(`${formData.role === t("User") ? "User" : "Operator"}Created`),
        type: "success",
        autoClose: 1500,
        isLoading: false,
      });

      onClose();
    } catch (err) {
      toast.update(id, {
        render: t(
          `${formData.role === t("User") ? "User" : "Operator"}NotCreated`
        ),
        type: "error",
        autoClose: 1500,
        isLoading: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.role) errors.role = t("FieldRequired");
    if (!formData.name) errors.name = t("FieldRequired");

    if (person && !formData.surname) errors.surname = t("FieldRequired");
    if (!person && !formData.pIva) errors.pIva = t("FieldRequired");

    if (!formData.email) {
      errors.email = t("FieldRequired");
    } else if (!isEmailValid(formData.email)) {
      errors.email = t("InsertValidMail");
    }

    if (formData.role === t("User")) {
      if (
        !formData.fiscalCode &&
        appConfig?.modules?.user?.createUserCFrequiredquired
      ) {
        errors.fiscalCode = t("FieldRequired");
      }
      if (!formData.adminId && role === ROLE.ADMIN) {
        errors.adminId = `Seleziona ${t("operator")}`;
      }
    }

    if (
      role === ROLE.ADMIN &&
      ((formData.role === t("User") && !formData.studioId && !isNewStudio) ||
        (formData.role === t("Operator") && !isNewStudio && !formData.studioId))
    ) {
      errors.studio = t("SelectStudio");
    }

    if (role === ROLE.ADMIN && isNewStudio && !formData.studioName) {
      errors.studioName = t("FieldRequired");
    }

    return errors;
  };

  const buildUserData = () => {
    const data = {
      name: formData.name,
      surname: formData.surname,
      email: formData.email,
      isCompany: !person,
      adminId: role === ROLE.ADMIN ? formData.adminId : myAdminId,
      studioId:
        role === ROLE.ADMIN && !isNewStudio ? formData.studioId : myStudioId,
    };

    if (person) {
      if (formData.fiscalCode) data.fiscalCode = formData.fiscalCode;
      if (formData.employmentStatusId)
        data.employmentStatusId = formData.employmentStatusId;
    } else {
      data.company = {
        name: formData.name,
        vat: formData.pIva,
        email: formData.email,
      };
    }

    if (formData.role === t("User") && selectedCompany) {
      data.userCompanyId = selectedCompany.value;
    }
    if (formData.role === t("User") && sendEmail) {
      data.skipEmailSending = sendEmail;
    }

    if (formData.role === t("Operator")) {
      data.adminProfileRoles = formData.adminProfileRoles;
    }
    if (formData.role === t("Operator") && isNewStudio) {
      data.createNewStudio = isNewStudio;
      data.studioName = formData.studioName;
      delete data.studioId;
    }
    if (formData.consent1 && formData.consent2 && formData.consent3) {
      data.consent1 = formData.consent1;
      data.consent2 = formData.consent2;
      data.consent3 = formData.consent3;
    }

    return data;
  };

  const handleChangeNewStudio = (event) => {
    const isNew = event.target.value === "true";
    setIsNewStudio(isNew);

    setFormData((prev) => {
      const { studioId, studioName, ...rest } = prev;

      return {
        ...rest,
        ...(isNew ? { studioName: "" } : { studioId: "" }),
      };
    });
  };

  useEffect(() => {
    if (studio?.id)
      setFormData({
        ...formData,
        studioId: studio?.id,
      });
    else
      setFormData({
        ...formData,
        studioId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studio?.id]);

  const handleChangeRadio = (event) => {
    setPerson(event.target.value === "true");
    setFormData({ ...formData });
    setSelectedCompany();
  };

  if (isLoadingStudios) return <CoreSpinner />;

  return (
    <div className="flex flex-col shadow-lg rounded-xl p-8 w-full">
      <div className="w-full">
        <CoreSelect
          onChange={handleInputChange}
          name="role"
          label={t("Role")}
          items={ruoli}
          value={formData.role}
          error={Boolean(validationErrors.role)}
          helperText={validationErrors.role}
          required={true}
          disabled
        />
      </div>

      {appConfig?.modules?.company?.formCreateUser &&
        formData.role === t("User") && (
          <RadioGroup
            row
            value={person}
            className="flex mt-4"
            onChange={handleChangeRadio}
          >
            <FormControlLabel
              value={true}
              control={<Radio size="small" />}
              label={t("NaturalPerson")}
            />
            <FormControlLabel
              value={false}
              control={<Radio size="small" />}
              label={t("LegalPerson")}
            />
          </RadioGroup>
        )}

      {formData.role === t("User") && person && (
        <>
          {appConfig?.modules?.company?.general && (
            <div className="py-5">
              <CompanyFilter //filtro per aziende
                selectedUser={selectedCompany}
                setSelectedUser={(v) => {
                  setSelectedCompany(v);
                  setValidationErrors((prev) => ({ ...prev, company: "" }));
                }}
                usersList={
                  companiesList?.Data?.items.map((el) => ({
                    label: el.name,
                    value: el.id,
                  })) || []
                }
                setDebouncedInputUserValue={setDebouncedInputCompanyValue}
                isUsersLoading={isCompanyLoading || isCompanyFetching}
                isError={validationErrors.company}
              />
            </div>
          )}
          <div className="mt-4">
            <CoreSelectObjArr
              name="employmentStatusId"
              label={t("SelectEmployment")}
              value={formData.employmentStatusId}
              error={Boolean(validationErrors.employmentStatusId)}
              helperText={validationErrors.employmentStatusId}
              items={dataListCategory?.Data.map((el) => ({
                label: el.name,
                value: el.id,
              }))}
              onChange={handleInputChange}
            />
          </div>
        </>
      )}

      {formData.role === t("Operator") && (
        <div className="w-full flex flex-col gap-5">
          {role === ROLE.ADMIN && (
            <div className="flex mt-3 justify-between items-center">
              <h3 className="m-0">{t("NewStudio")}</h3>
              <RadioGroup
                row
                value={isNewStudio}
                className="flex"
                onChange={handleChangeNewStudio}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio size="small" />}
                  label={t("Yes")}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio size="small" />}
                  label={t("No")}
                />
              </RadioGroup>
            </div>
          )}

          <FormControl size="small" className="w-full mt-3">
            <CoreSelectObjArr
              name="adminProfileRoles"
              label={t("OperatorType")}
              value={formData.adminProfileRoles}
              items={OPERATOR_TYPES}
              onChange={handleInputChange}
              isFull={true}
            />
          </FormControl>
        </div>
      )}
      {person ? (
        <>
          <CoreInputField
            label={t("Name")}
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.name)}
            helperText={validationErrors.name}
          />

          <CoreInputField
            label={t("Surname")}
            type="text"
            name="surname"
            value={formData.surname}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.surname)}
            helperText={validationErrors.surname}
          />

          <CoreInputField
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.email)}
            helperText={validationErrors.email}
          />

          {formData.role === t("User") && (
            <CoreInputField
              label={t("CF")}
              type="text"
              name="fiscalCode"
              value={formData.fiscalCode}
              onChange={handleInputChange}
              required={appConfig?.modules?.user?.createUserCFrequiredquired}
              error={Boolean(validationErrors.fiscalCode)}
              helperText={validationErrors.fiscalCode}
            />
          )}
        </>
      ) : (
        <>
          <CoreInputField
            label={t("CompanyName")}
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.name)}
            helperText={validationErrors.name}
          />

          <CoreInputField
            label={t("VAT")}
            type="text"
            name="pIva"
            value={formData.pIva}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.pIva)}
            helperText={validationErrors.pIva}
          />

          <CoreInputField
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.email)}
            helperText={validationErrors.email}
          />
        </>
      )}
      {sendEmailOption && (
        <div className="flex justify-between items-center">
          <h3 className="mt-2">{t("Inviare email di registrazione?")}</h3>
          <RadioGroup
            row
            value={sendEmail.toString()}
            className="flex"
            onChange={handleSendEmailChange}
          >
            <FormControlLabel
              value="false"
              control={<Radio size="small" />}
              label={t("Yes")}
            />
            <FormControlLabel
              value="true"
              control={<Radio size="small" />}
              label={t("No")}
            />
          </RadioGroup>
        </div>
      )}
      <div className="mt-1 w-full">
        {role === ROLE.ADMIN &&
          (isNewStudio ? (
            <CoreInputField
              label={t("StudioName")}
              className={"w-full"}
              type="text"
              name="studioName"
              value={formData.studioName}
              onChange={handleInputChange}
              required={true}
              error={Boolean(validationErrors.studioName)}
              helperText={validationErrors.studioName}
            />
          ) : (
            <StudioFilter
              selectedUser={studio}
              setSelectedUser={(v) => {
                setStudio(v);
                setValidationErrors((prev) => ({ ...prev, studio: "" }));
              }}
              usersList={studios?.Data?.items}
              setDebouncedInputUserValue={setDebouncedInputStudioValue}
              isError={validationErrors.studio}
              error={Boolean(validationErrors.studio)}
              helperText={validationErrors.studio}
            />
          ))}

        {formData.role === t("User") && formData.studioId && (
          <FormControl fullWidth size="small">
            {isLoading || isFetching ? (
              <CoreSpinner style={{ color: `${colorPrimary}` }} />
            ) : (
              <div className="mt-4">
                <CoreSelectObjArr
                  required
                  name="adminId"
                  label={`${t("SelectOperator")}`}
                  value={formData.adminId}
                  onChange={handleInputChange}
                  items={commercialistiOptions || []}
                  error={Boolean(validationErrors.adminId)}
                  helperText={validationErrors.adminId}
                />
              </div>
            )}
          </FormControl>
        )}
      </div>

      {appConfig?.modules?.user?.consentCreatedUser && (
        <div className="mt-4 flex gap-x-2">
          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent1")}
            control={
              <Checkbox
                checked={formData.consent1}
                onChange={(e) =>
                  setFormData({ ...formData, consent1: e.target.checked })
                }
              />
            }
          />

          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent2")}
            control={
              <Checkbox
                checked={formData.consent2}
                onChange={(e) =>
                  setFormData({ ...formData, consent2: e.target.checked })
                }
              />
            }
          />

          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent3")}
            control={
              <Checkbox
                checked={formData.consent3}
                onChange={(e) =>
                  setFormData({ ...formData, consent3: e.target.checked })
                }
              />
            }
          />
        </div>
      )}

      <Box
        sx={{
          width: "20px",
          textAlign: "left",
          marginTop: 3,
        }}
      >
        <CoreButton
          className={"btn-round"}
          variant="contained"
          testo={t("Create")}
          onClick={handleSubmit}
          disabled={isCommercialistaLoading || isUserLoading}
        />
      </Box>
    </div>
  );
};
